import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

const style = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 20,
  },
  labelText: {
    fontWeight: '400',
    color: colors.black,
  },
  paginationInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputContainer: {
    width: 60,
    marginHorizontal: 8,
  },
  pageInput: {
    width: '100%',
    height: 40,
    borderBottomWidth: 2,
    borderColor: colors.newUI.therapist.primaryBlue80,
    backgroundColor: colors.newUI.therapist.bgBlue10,
    fontSize: 16,
    fontWeight: '500',
    color: colors.black,
    textAlign: 'center',
    paddingVertical: 4,
    paddingHorizontal: 0,
  },
});

export default style;
